const ParticipantStatusOverlay = ({ status }) => {
   
  if (status !== 'waiting' && status !== 'rejected') return null;

  const isWaiting = status === 'waiting';
  return (
    <div className="absolute inset-0 bg-black bg-opacity-90 flex flex-col items-center justify-center z-50">
      <h2 className={`text-2xl font-semibold mb-4 ${isWaiting ? 'text-white' : 'text-red-500'}`}>
        {isWaiting ? 'Waiting for host to admit you...' : 'You have been rejected by the host.'}
      </h2>
      {isWaiting ? (
        <div className="w-8 h-8 border-4 border-white border-t-transparent rounded-full animate-spin" />
      ) : (
        <p className="text-sm text-gray-300">Please contact the host or try again later.</p>
      )}
    </div>
  );
};

export default ParticipantStatusOverlay;
